import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $state, $q, $stateParams, $window, SearchService, ViewModelService, ModalService, AccountService) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.feedback = {};
    };

    ctrl.SubmitFeedbackForm = function (feedbackForm, feedback) {
        console.log(feedbackForm);
        feedbackForm.submitted = true;
        $scope.contact = true;

        if (feedbackForm.$invalid) {
            console.log(feedbackForm);
            return feedbackForm.submitted;
        } else {

            var arr = Object.values(feedback);
            var html = "";
            $scope.mailLink = "mailto:" + $scope.feedback.phonenumber;
            console.log($scope.mailLink);
            var newContent = html + '<div> <u>' + "Question :" + '</u>' + '<u>' + "Answer" + '</u>' + '</div>' + '\n' + html + '<div> <label>' + "Your Name :" + '</label>' + '<label>' + feedback.name + '</label>' + '</div>' + '\n' + html + '<div> <label>' + "Business Name :" + '</label>' + '<label>' + feedback.business_name + '</label> </div>' + '\n' + html + '<div> <label>' + "Preferred Method of Contact :" + '</label>' + '<label>' + feedback.preferred_method + '</label> </div>' + '\n' + html + '<div class="msf-padding-top-10"> <label>' + "Phone Number and/or Email address :" + '</label>' + '<a ng-href="{{mailLink}}">' + feedback.phonenumber + '</a> </div>' + '\n' + html + '<div> <label>' + "Location :" + '</label>' + '<label>' + feedback.location + '</label> </div>' + '\n' + html + '<div> <label>' + "Your Question/Comment :" + '</label>' + '<label>' + feedback.question + '</label> </div>';

            console.log(newContent);

            //DEF0793-GHC-Error handing - Handled error case and success case in a proper way
            $scope.saveNotePromise = AccountService.sendMail(newContent).then(function (response) {
                console.log(response);
                $scope.registered = true;
                $scope.reset();
                ModalService.showInfo('', 'Mail has been sent successfully');
            }, function (error) {
                var errorMsg = 'Unable to send Email.';
                if (error.baseError.error.message) errorMsg = error.baseError.error.message;
                ModalService.showError('', errorMsg);
            });
        }
    };

    ctrl.reset = function (feedback) {
        $scope.contact = false;
        $scope.feedbackForm.submitted = false;
        $scope.feedback = {};
    };
    //DEF1375-TS09-TC031-Message is not refreshed when clicking on clear forms
    ctrl.resetContact = function (feedback) {
        $scope.registered = false;
        $scope.contact = false;
        $scope.feedbackForm.submitted = false;
        $scope.feedback = {};
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', '$q', '$stateParams', '$window', 'SearchService', 'ViewModelService', 'ModalService', 'AccountService'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/GatewayContactUsCtrl.js
// module id = 1673
// module chunks = 0